import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";

export const FilterExerciseVideoList = ({
  exercises = [],
  exerciseFilters,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [filterState, setFilterState] = useState([""]);
  useEffect(() => {
    if (exerciseFilters) {
      setFilterState(JSON.parse(exerciseFilters));
    }
  }, [exerciseFilters]);

  const handleSelectionChange = (value) => {
    let data = JSON.parse(JSON.stringify(filterState));
    if (!filterState.includes(value)) {
      data.length === 1 && data[0].length === 0
        ? (data = [value])
        : data.push(value);
    } else {
      if (filterState.length > 0) {
        const filetered = data.filter((val) => val != value);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setFilterState(data);
  };
  const setFiltersSubmit = () => {
    const hasFilters = filterState.length > 0 && filterState[0].length !== 0;

    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        exerciseFilters: hasFilters ? JSON.stringify(filterState) : "",
        // the filter is applied server side, so the result set changes: whatever
        // page the list was on no longer means anything
        pageToShow: 1,
        modal: "",
      },
    });
  };
  return (
    <Modal
      className={"filter-video-modal"}
      title={t("filterExerciseVideoList.title")}
    >
      <div className="body">
        {exercises.length > 0 && (
          <div
            role="checkbox-wrapper"
            onClick={() =>
              setFilterState(
                filterState.length === exercises.length ? [] : exercises
              )
            }
            className={filterState.length === exercises.length ? "active" : ""}
          >
            <SvgIcon
              src={
                filterState.length === exercises.length
                  ? "/img/new-icons/checked-square.svg"
                  : "/img/new-icons/unchecked-square.svg"
              }
              noFilterOnLight={filterState.length === exercises.length}
            />
            <span>{t("filterExerciseVideoList.selectAll")}</span>
          </div>
        )}
        <div className="video-filters-wrapper">
          {exercises.map((exercise, index) => {
            const included = filterState.includes(exercise);
            return (
              <div
                role="checkbox-wrapper"
                key={`${exercise}${index}`}
                id={`${exercise}${index}`}
              >
                <SvgIcon
                  src={
                    included
                      ? "/img/new-icons/checked-square.svg"
                      : "/img/new-icons/unchecked-square.svg"
                  }
                  onClick={() => handleSelectionChange(exercise)}
                  noFilterOnLight={included}
                />

                <span>
                  {exercise.charAt(0).toUpperCase() + exercise.slice(1)}
                </span>
              </div>
            );
          })}
        </div>
      </div>
      <footer>
        <button
          data-button-type="secondary"
          onClick={() => setFilterState([""])}
        >
          {t("filterExerciseVideoList.clearAll")}
        </button>

        <button data-button-type="primary" onClick={setFiltersSubmit}>
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};
